document.addEventListener("DOMContentLoaded", function () {
  function updateWishlistCount() {
    const counter = document.querySelector(".Vtl-WishlistHeader__HeartCounter");
    const mobileCounter = document.querySelector("#mobileWishlistCounter");

    if (counter && mobileCounter) {
      const count = counter.textContent.trim();
      mobileCounter.textContent = count;
    }
  }

  // Run once on load
  updateWishlistCount();

  // Run again after slight delay (for Shopify async rendering)
  setTimeout(updateWishlistCount, 1000);
});



document.addEventListener("click", function (e) {
  const path = e.composedPath();

  const clickedWishlist = path.some(el =>
    el.classList && el.classList.contains("Vtl-WishlistButton__IconWrapper")
  );

  if (clickedWishlist) {
    // wait for app to update counter
    setTimeout(() => {
      const counter = document.querySelector(".Vtl-WishlistHeader__HeartCounter");
      const count = counter ? counter.textContent.trim() : "0";
      $('#mobileWishlistCounter').text(count);
    }, 500); 
  }
}, true);

document.addEventListener("DOMContentLoaded", function() {
  const video = document.querySelector("video");
  if (video) video.play().catch(error => console.log("Autoplay failed:", error));
});

document.querySelectorAll('.h2').forEach(el => el.remove());


